import { QuestionType } from '@studyportals/profile-questionnaires-interfaces';
import { EventType } from '../enums';
import { IEvent } from '@studyportals/event-aggregation-service-interface';

export class BestfitQuestionModificationRequestEvent implements IEvent {
	public static EventType: string = EventType.BESTFIT_MODIFY_ANSWER;

	public readonly timestamp: Date;
	public readonly questionType: QuestionType;
	public readonly eventType: string = BestfitQuestionModificationRequestEvent.EventType;

	constructor(questionType: QuestionType) {
		this.questionType = questionType;
		this.timestamp = new Date();
	}
}
